import { render, staticRenderFns } from "./PerformChangePassword.modal.vue?vue&type=template&id=6efa51c5&"
import script from "./PerformChangePassword.modal.vue?vue&type=script&lang=ts&"
export * from "./PerformChangePassword.modal.vue?vue&type=script&lang=ts&"
import style0 from "./PerformChangePassword.modal.vue?vue&type=style&index=0&id=6efa51c5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports